import { useCookie } from '#app'

export default defineNuxtPlugin(() => {
  const device = useDevice()
  const layout = useCookie('layout')
  if (!device.isApple || !device.isSafari) {
    useCookie('layout').value = null
  }
  if (layout.value === 'mobile' || device.isMobileOrTablet) {
    device.isMobile = true
    return
  }
  if (import.meta.client) {
    if ((navigator?.maxTouchPoints && device.isApple) || device.isMobileOrTablet) {
      device.isMobile = true
      layout.value = 'mobile'
      window.location.reload()
    }
  }
})
